<div class="add-income-container">
  <div class="form-element">
    <p [innerHtml]="referenceDataLabels.IncomeFromOutsideUK | localizeLabel" class="income-title"></p>
  </div>
  <div class="form-element income-description vo-info-box--warning my-15">
    <p [innerHtml]="referenceDataLabels.IncomeFromOutsideUKDescription | localizeLabel"></p>
  </div>
  <boi-validation-error [propertyNames]="['Applicant' + '_' + applicantIndex + '.' + 'ApplicantIncomeFromOutsideUKs']">
  </boi-validation-error>

  <ng-container *ngIf="applicant.ApplicantIncomeFromOutsideUKs">
    <ng-container *ngFor="let income of applicant.ApplicantIncomeFromOutsideUKs; index as incomeIndex">
      <div class="income-type vo-panel-grey p-15 px-md-0 d-flex my-15 flex-column">
        <div class="d-flex flex-row justify-content-between mx-15">
          <p
            class="income-country"
            [innerHtml]="income.IncomeCountryISOCode | localizeOption : referenceDataOptionLists.Country"
          ></p>
          <button
            [disabled]="mortgageApplication?.IsApplicationReadOnly"
            class="remove-button vo-icon vo-icon-recycle-bin cursor-pointer"
            (click)="removeIncome(income)"
            title="Remove"
          ></button>
        </div>

        <div class="form-element income-field">
          <boi-form-numeric-input
            [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
            [controlId]="'IncomePercentage ' + incomeIndex"
            [labelName]="referenceDataLabels.IncomeFromOutsideUKPercentage"
            [(value)]="income.IncomePercentage"
            [propertyNames]="[
              'Applicant' +
                '_' +
                applicantIndex +
                '.' +
                'ApplicantIncomeFromOutsideUK_' +
                incomeIndex +
                '.IncomePercentage'
            ]"
            [contextualHelpName]="'IncomeFromOutsideUK'"
            [fieldMaxLength]="5"
            [decimals]="2"
            class="income-outside-uk"
          >
          </boi-form-numeric-input>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <div class="add-new-container vo-panel-grey p-15 px-md-0 d-flex flex-wrap my-15">
    <boi-form-option-list
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [availableOptions]="
        referenceDataOptionLists.Country
          | localizeOptionListFilteredByAttribute
            : referenceDataConstants.CountryExcludeFromApplicantIncomeOptionsAttributeName
      "
      [contextualHelpName]="referenceDataLabels.IncomeFromOutsideUK"
      [labelName]="referenceDataLabels.AddNewIncomeFromOutsideUK"
      [(value)]="selectedCountryCode"
    >
    </boi-form-option-list>

    <button
      class="primary-button vo-secondary-button-1 align-self-center"
      (click)="addNewIncome()"
      [disabled]="!canAddNewIncome() || mortgageApplication?.IsApplicationReadOnly"
      title="{{ referenceDataLabels.Add | localizeLabel }}"
    >
      {{ referenceDataLabels.Add | localizeLabel }}
    </button>
  </div>
</div>
